import { MutableRefObject, useCallback, useEffect, useState } from 'react';

export function useComponentSize(ref: MutableRefObject<any>): [number, number] {
    let [size, setSize] = useState<{ width: number; height: number }>({ width: 0, height: 0 });

    const getSize = useCallback(() => {
        setSize(ref.current.getBoundingClientRect());
    }, []);

    useEffect(() => {
        window.addEventListener('resize', getSize);
        getSize();
        return () => window.removeEventListener('resize', getSize);
    }, []);

    return [size.width, size.height];
}
